// Qué se enseña en `/login` cuando ya hay sesión.
//
// Antes la ruta decidía sola: `user ? <RoleHome/> : <Login/>`. O sea, con sesión
// abierta nunca se enseñaba la pantalla de entrada — se repartía por rol. Y ahí
// había dos fallos encadenados:
//
//   · Quien tenía sesión pero NO cuenta (entró con Google y no llegó a elegir
//     tipo de cuenta) era repartido a `/home` como si existiera. Desde ahí todo
//     lo que intentaba guardar moría por clave foránea, con un 500 en la cara.
//     Así entraron las dos cuentas del 2026-08-16.
//   · Y con `ProfileGate` puesto, ese mismo rebote se volvió un BUCLE: la
//     guardia manda a `/login`, `/login` reparte a `/home`, la guardia devuelve
//     a `/login`. La app se queda en blanco para siempre y sin un solo error,
//     porque una redirección no pinta nada.
//
// La regla es una línea: al repartidor por rol solo se llega TENIENDO cuenta.
import { useAuth } from '../context/AuthContext';

export default function EntradaGate({ entrada, home, cargando }) {
  const { user, userProfile, profileLoaded } = useAuth();
  if (!user) return entrada;
  // Se espera al perfil antes de decidir: quien SÍ tiene cuenta también pasa por
  // vacío mientras carga, y sin la espera vería un parpadeo de la pantalla de
  // entrada en cada arranque.
  if (!profileLoaded) return cargando;
  return userProfile ? home : entrada;
}
